// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"hero_heroContainer__9tPd-","bigOne":"hero_bigOne__28slH","content":"hero_content__3ohcC"};